import axios from "axios";

const normalizeBaseUrl = () => {
  const rawUrl = process.env.REACT_APP_ITEMS_API_URL;

  if (typeof rawUrl !== "string") {
    return undefined;
  }

  const trimmedUrl = rawUrl.trim();

  if (!trimmedUrl || ["undefined", "null"].includes(trimmedUrl.toLowerCase())) {
    return undefined;
  }

  return trimmedUrl.replace(/\/$/, "");
};

const getBaseUrl = () => {
  const baseUrl = normalizeBaseUrl();

  if (!baseUrl) {
    throw new Error("Items API URL is not configured.");
  }

  return baseUrl;
};

const submitContactRequest = async (payload) => {
  const baseUrl = getBaseUrl();
  const response = await axios.post(`${baseUrl}/contact`, payload);

  return response.data;
};

const ContactService = {
  submitContactRequest,
  isConfigured: () => Boolean(normalizeBaseUrl()),
};

export default ContactService;
